<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item><a @click="BackGo">历史总分</a></el-breadcrumb-item>
                        <el-breadcrumb-item>员工KPI</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <HistoryUserListKPI :pt="0"></HistoryUserListKPI>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <HistoryUserListKPI :pt="1"></HistoryUserListKPI>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import HistoryUserListKPI from "../KPI/HistoryUserListKPI";
export default {
  data() {
    return {
      activeName: "month",
    };
  },
  components: {
    HistoryUserListKPI
  },
  methods:{
      BackGo:function(){
          console.log('返回上一个页面');
          window.history.back(-1); 
      }
  }
}
</script>
